import { combineReducers } from "redux";

import layer from "./layer-reducer";

export default combineReducers({
  layer
});
